<template>
  <div v-loading="loadingx">
    <el-form-item :label="title">
      <el-input
        style="width: 100%; margin-top: 5px"
        v-model="address_"
        @change="changeAddres"
        placeholder="请输入位置后点击右侧图标确定坐标"
      >
        <i
          slot="suffix"
          class="dnnfont iconrenyuandingwei"
          style="cursor: pointer; color: #666666"
          @click="openMap"
        ></i
      ></el-input>
    </el-form-item>
    <el-dialog
      :visible.sync="innerVisible"
      append-to-body
      :fullscreen="true"
      @opened="initMap"
    >
      <span slot="title">
        <el-select
          v-model="posValue"
          filterable
          remote
          :remote-method="remoteMethod"
          :loading="loading"
          placeholder="请输入区域关键词（如：南京、安徽、北京）"
          @change="posChange"
          style="width: 500px"
        >
          <!-- value 使用index和lonlat进行拼接，原因是lonlat可能存在重复 -->
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.name + '（' + item.address + '）'"
            :value="index + '_' + item.lonlat.toString()"
          ></el-option>
        </el-select>
      </span>

      <div id="map" class="map" v-loading="loadings"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button
          :loading="confirmLoading"
          type="primary"
          @click="positions(position)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { API__Position } from "@/api/index.js";
import {
  sendThis,
  Load_Map,
  addDrawPoint,
  addPoint,
  rewritePos,
  rewritePos2,
  toLonLat_,
  isNormalCoordinates,
  bd09ToMercator,
} from "@/views/administrator/console/assembly/openlayers/iMap.js";
import axios from "axios";
// 2025年 本地中国行政区划json文件
import provinces from "@/views/administrator/console/assembly/openlayers/provinces.json"; //省级
import cities from "@/views/administrator/console/assembly/openlayers/cities.json"; //市级
import areas from "@/views/administrator/console/assembly/openlayers/areas.json"; //县区级

export default {
  props: {
    selected: {
      //地址选择的默认选项
      type: Object,
      default: function () {
        return {
          province: "320000",
          city: "320100",
          area: "320115",
          town: "320115010",
        };
      },
    },
    address: {
      //地址文字地址
      type: String,
      default: "",
    },
    lonLat: {
      //坐标数据 本项目中看，最早存入的是网络地图投影坐标，所以这里通常也是投影坐标
      type: String,
      default: "",
    },
    position_: {
      type: Array,
      default: function () {
        return [118.846567, 31.958527];
      },
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      position: [118.846567, 31.958527],
      innerVisible: false,
      selected_: this.selected,
      address_: this.address,
      posValue: "",
      loading: false,
      options: [],
      shangxian: 1,
      loadingx: false,
      loadings: true,
      token: "",
      checkCode: "",
      id: "",
      ischange: true,
      confirmLoading: false,

      TDU_Key_Arr: [
        "d64700efc1e349f99ba65c45b170e130",
        "f3f9c73ee666232171858d458fb320b0",
      ], //公司的天地图密钥
      TDU_Key: "",
      selectedItem: null,
    };
  },
  mounted() {
    this.TDU_Key =
      this.TDU_Key_Arr[Math.floor(Math.random() * this.TDU_Key_Arr.length)];
    if (document.cookie.length > 0) {
      var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("="); //再次切割
        //判断查找相对应的值
        if (arr2[0] == "dnnyptadmin_token") {
          this.token = arr2[1]; //保存到保存数据的地方
        } else if (arr2[0] == "dnnyptadmin_checkCode") {
          this.checkCode = arr2[1];
        } else if (arr2[0] == "dnnyptadmin_id") {
          this.id = arr2[1];
        }
      }
    }
  },
  methods: {
    openMap() {
      this.address_ = this.address_.split(" ").join("");
      this.innerVisible = true;
    },
    initMap() {
      sendThis(this);
      var param = {
        photography: false,
        popup: false,
        mappParma: {
          zoom: 12,
          mapCenter:
            this.position == "" ? [118.846567, 31.958527] : this.position,
        },
      };
      Load_Map(param);
      addDrawPoint();
      addPoint();
      this.posValue = "";
      if (this.lonLat != "") {
        // 判断是否存在经纬度数据（此数据可能为网络地图投影坐标，也可能是百度坐标，数据库内要求录入的是地图投影坐标）
        let aa = this.lonLat.split(",");
        let bb = [parseFloat(aa[0]), parseFloat(aa[1])];
        if (isNormalCoordinates(bb[0], bb[1])) {
          // 如果是正常的坐标数据，那么在本项目中极大可能是百度坐标，直接使用rewritePos定位
          rewritePos(bb);
        } else {
          // 如果不是正常坐标数据,那就是地图投影坐标，使用rewritePos2定位
          rewritePos2(bb);
        }
      } else {
        // 没有经纬度数据，则根据输入的地名进行查询（需要稍微精准点的位置名称）
        this.initRemote(this.address_);
      }
    },
    initRemote(query) {
      if (query != "") {
        this.getSearchAddress(query, true);
      }
    },
    positions(coordinate) {
      this.confirmLoading = true;
      if (coordinate) {
        this.position = coordinate;
      } else {
        this.position = this.posValue.split("_")[1];
      }
      
      if(this.address_ == ""){
        // 如果外层没有输入地址，则使用当前搜索返回的数据，通过选择拿到的name作为地址
        this.address_ = this.selectedItem.name;
      }
      let param = {
        position: this.position,
        address: this.address_,
        selected: {
          province: {
            key: "",
            value: "",
          },
          city: {
            key: "",
            value: "",
          },
          area: {
            key: "",
            value: "",
          },
        },
      };

      if (this.selectedItem) {
        // 需要本地中国行政区划json文件查询
        let { province, city, county, name } = this.selectedItem;
        // 省
        let itemA = provinces.filter((item) => {
          return item.name == province;
        });
        let provinceKey = itemA && itemA.length > 0 ? itemA[0].code : "";
        // 市
        let itemB = cities.filter((item) => {
          return item.name == city;
        });
        let cityKey = itemB && itemB.length > 0 ? itemB[0].code : "";
        // 县、区
        let itemC = areas.filter((item) => {
          return item.name == county;
        });
        let areaKey = itemC && itemC.length > 0 ? itemC[0].code : "";
        param.selected = {
          province: {
            key: provinceKey,
            value: province,
          },
          city: {
            key: cityKey,
            value: city,
          },
          area: {
            key: areaKey,
            value: county,
          },
        };
      } else if (this.selected_) {
        let provinceKey = this.selected_.province;
        let cityKey = this.selected_.city;
        let areaKey = this.selected_.area;
        // 省
        let itemA = provinces.filter((item) => {
          return item.code == provinceKey;
        });
        let province = itemA && itemA.length > 0 ? itemA[0].name : "";
        // 市
        let itemB = cities.filter((item) => {
          return item.code == cityKey;
        });
        let city = itemB && itemB.length > 0 ? itemB[0].name : "";
        // 县、区
        let itemC = areas.filter((item) => {
          return item.code == areaKey;
        });
        let county = itemC && itemC.length > 0 ? itemC[0].name : "";
        param.selected = {
          province: {
            key: provinceKey,
            value: province,
          },
          city: {
            key: cityKey,
            value: city,
          },
          area: {
            key: areaKey,
            value: county,
          },
        };
      }
      console.log("param", param);
      
      this.$emit("backPram", param);
      this.innerVisible = false;
      this.confirmLoading = false;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.getSearchAddress(query);
      }
    },
    posChange() {
      let index = this.posValue.split("_")[0];
      let temp = this.posValue.split("_")[1];
      this.selectedItem = this.options[index];
      this.position = [Number(temp.split(",")[0]), Number(temp.split(",")[1])];
      rewritePos2(this.position);
      //此时 this.position 的数据以及被处理过 具体可以去iMap.js 文件搜索rewritePos2查看
      console.log("posChange-position", this.position);
    },
    changItem(param) {
      this.address_ = param;
    },
    changePro(param) {
      this.shangxian = 2;
      this.selected_ = param;
    },
    changePos(pos) {
      let self = this;
      this.ischange = false;
      setTimeout(function () {
        self.position = pos;
        // self.posChange();
      });
    },
    changeAddres() {
      this.$emit("update:address", this.address_);
      this.ischange = true;
    },
    async getSearchAddress(keyword, isInitSearch) {
      let self = this;
      const postStr = {
        keyWord: keyword,
        level: 2, // 省级级别，输入“南京”会自动降级为市级
        mapBound: "73.4,3.8,135.0,53.5", //中国大致地理范围，暂时不包含存在争议的地理位置
        queryType: 2, // 行政区划查询（优先返回省/市/区）
        queryRadius: 300000, // 300公里（接口上限，覆盖省级区域）
        start: 0,
        count: 15, // 最多返回15条结果
        show: 2, //返回详细poi信息
      };

      const params = new URLSearchParams();
      params.append("postStr", JSON.stringify(postStr));
      params.append("type", "query");
      params.append("tk", this.TDU_Key);
      const url = `https://api.tianditu.gov.cn/v2/search?${params.toString()}`;

      this.loading = true;
      const res = await axios.get(url);

      if (res.status === 200 && res.data.status.infocode === 1000) {
        const resData = res.data;
        console.log("resData", resData);

        // 整合结果：1. 行政区划结果（从prompt提取） 2. 区域内POI（从pois提取）
        let allResults = [];

        // 1. 提取行政区划结果（自动获取，无需预设）
        if (resData.prompt && resData.prompt.length > 0) {
          resData.prompt.forEach((prompt) => {
            if (prompt.admins && prompt.admins.length > 0) {
              prompt.admins.forEach((admin) => {
                // 自动拼接完整区域名称（如“南京市”“安徽省合肥市”）
                const fullName = admin.adminName.includes(keyword)
                  ? admin.adminName
                  : `${keyword}${admin.adminName}`;

                // 自动获取区域中心点经纬度（接口返回的adminCode反向解析，或用接口默认值）
                // 天地图接口未直接返回行政区划经纬度，此处调用天地图地理编码接口获取
                this.getAdminLonLat(fullName).then((res) => {
                  if (res) {
                    allResults.push({
                      name: fullName,
                      address: `${fullName}（行政区划）`,
                      lonlat: res,
                      type: "admin",
                    });
                    // 重新渲染列表（确保行政区划结果显示）
                    renderList(allResults.concat(data.pois || []));
                  }
                });
              });
            }
          });
        }

        // 2. 提取区域内POI结果
        if (resData.pois && resData.pois.length > 0) {
          const poiResults = resData.pois.map((poi) => ({
            name: poi.name,
            address: poi.address,
            lonlat: poi.lonlat,
            type: "poi",
            province: poi.province,
            provinceCode: poi.provinceCode,
            city: poi.city,
            cityCode: poi.cityCode,
            county: poi.county,
            countyCode: poi.countyCode,
          }));
          allResults = allResults.concat(poiResults);
          this.renderList(allResults);
        }
        this.loading = false;
        // 初始化后立即搜索且赋值搜索结果

        if (isInitSearch) {
          setTimeout(() => {
            self.posValue = "0_" + allResults[0].lonlat.toString(); //select的value值是index_lonlat，所以此处拼接一下
            self.posChange();
          }, 1000);
        }
      } else {
        let errorMsg =
          res.status === 200 ? res.data.status.cndesc : res.statusText;
        this.$message({
          message: `请求失败： ${errorMsg || "未知错误"}`,
          type: "error",
        });
        this.loading = false;
      }
    },
    // 自动获取行政区划的经纬度（调用天地图地理编码接口，无需预设）
    getAdminLonLat(adminName) {
      const ds = JSON.stringify({ keyWord: adminName });
      const geocodeUrl = `https://api.tianditu.gov.cn/geocoder?ds=${encodeURIComponent(
        ds,
      )}&tk=${this.TDU_Key}`;

      return axios
        .get(geocodeUrl)
        .then((res) => {
          const data = res.data;
          if (data && data.location && data.location.length > 0) {
            const { lng, lat } = data.location[0];
            return `${lng},${lat}`;
          }
          return null;
        })
        .catch(() => null);
    },

    // 渲染联想列表（自动显示行政区划+POI）
    renderList(results) {
      // 去重后显示
      const uniqueResults = this.deduplicateResults(results);
      this.options = uniqueResults;
    },
    // 去重
    deduplicateResults(results) {
      const nameSet = new Set();
      const uniqueResults = [];
      results.forEach((item) => {
        if (!nameSet.has(item.name)) {
          nameSet.add(item.name);
          uniqueResults.push(item);
        }
      });
      return uniqueResults;
    },
  },
};
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: 75vh;
}
</style>



// WEBPACK FOOTER //
// GisCommon.vue?6b601af9